/* page-dog-portraits.js — three progressive enhancements:
   1. Set --dp-hero-ratio from the loaded hero image's natural dimensions,
      so a future hero swap with different native dimensions just works.
   2. Defend against the iOS Safari orientation cache (portrait ->
      landscape -> portrait keeps the landscape grid widths).
   3. Set --ngv-header-clearance from the theme's rendered header (and
      announcement bar if present), so the page survives theme-setting
      changes (logo size, header style, announcement enabled).
   All three degrade silently: CSS holds sensible fallbacks. Step 2 is
   placed BEFORE step 3's early returns so it runs even on browsers
   without ResizeObserver.
   See CLAUDE_DESIGN_TO_SHOPIFY.md sections 6, 7, 11. */
(function () {
  var root = document.getElementById('ngv-dog-portraits');
  if (!root) return;

  /* 1. Aspect-ratio observer */
  function setRatioFromImg(img, varName) {
    if (!img) return;
    function apply() {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w > 0 && h > 0) root.style.setProperty(varName, w + ' / ' + h);
    }
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }
  setRatioFromImg(root.querySelector('.dp-hero-img'), '--dp-hero-ratio');

  /* 2. iOS Safari orientation reflow */
  function forceReflow() {
    var d = root.style.display;
    root.style.display = 'none';
    void root.offsetHeight;
    root.style.display = d || '';
  }
  function onOrientation() {
    setTimeout(forceReflow, 50);
    setTimeout(forceReflow, 300);
  }
  window.addEventListener('orientationchange', onOrientation);
  if (window.matchMedia) {
    var mq = window.matchMedia('(orientation: portrait)');
    if (mq.addEventListener) mq.addEventListener('change', onOrientation);
    else if (mq.addListener) mq.addListener(onOrientation);
  }

  /* 3. Header clearance observer */
  if (!('ResizeObserver' in window)) return;
  var headerEls = [
    document.querySelector('.xo-announcement-bar'),
    document.querySelector('.xo-header__sticky')
  ].filter(Boolean);
  if (!headerEls.length) return;
  function updateClearance() {
    var total = 0;
    headerEls.forEach(function (el) { total += el.getBoundingClientRect().height; });
    /* Cap at 160px — defense against iOS Safari measuring the
       pre-hydration announcement-bar carousel or drawer-menu subtree
       as hundreds of pixels tall. CSS also caps via min(...). */
    if (total > 0) {
      var capped = total > 160 ? 160 : total;
      root.style.setProperty('--ngv-header-clearance', capped + 'px');
    }
  }
  var ro = new ResizeObserver(updateClearance);
  headerEls.forEach(function (el) { ro.observe(el); });
  updateClearance();
  if (document.readyState === 'complete') updateClearance();
  else window.addEventListener('load', updateClearance);
})();
